import {
  ApolloCache,
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  HttpLink,
  Observable,
  split,
} from "@apollo/client";
// import { RetryLink } from "@apollo/client/link/retry";
import { useAuth } from "react-oidc-context";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import React, { FC } from "react";
import { GRAPHQL_API_URL, GRAPHQL_SUBSCRIPTION_URL } from ".";
import {
  DollarFollowMutation,
  DollarTag,
  DollarTagFieldsFragmentDoc,
  Hashtag,
  HashTagFieldsFragmentDoc,
  Maybe,
  UpdateHashtagFragmentDoc,
  DollarTagEnum,
  User,
  FollowMutation,
  UpdateUserFragmentDoc,
  UnfollowMutation,
  CancelFollowMutation,
  SubscribeMutation,
  UnsubscribeMutation,
  Club,
  Comment,
  UpdateClubFragmentDoc,
  UserFieldsFragmentDoc,
  JoinClubMutation,
  LeaveClubMutation,
  SubscribeClubMutation,
  UnsubscribeClubMutation,
  UpvoteMutation,
  UpdateCommentFragmentDoc,
  RemoveUpvoteMutation,
  RemoveDownvoteMutation,
  DownvoteMutation,
  UpdateReplyFragmentDoc,
  Reply,
} from "api";
import cache from "./cache";

// const accessToken = `eyJhbGciOiJSUzI1NiIsImtpZCI6IjNENkRCQUIwNTAzRjU1MjJDOTg4QTcyMDgwQjY3RERCIiwidHlwIjoiand0In0.eyJuYmYiOjE3MDcyNzg4NDQsImV4cCI6MTcwNzI3OTAyNCwiaXNzIjoiaHR0cHM6Ly9zdGFnaW5nMS1hY2NvdW50cy5zdG9ja2VkZ2UuY29tIiwiYXVkIjoiYXBpc29jaWFsLnN0b2NrZWRnZS5jb20iLCJjbGllbnRfaWQiOiJERTc0MEY2OS1CMEE5LTQ0MkMtQjA1Qi0yOTJFM0U2NEFEQTgiLCJzdWIiOiI2NjUzZWEwZi1hY2I2LTRkM2ItYTlhNC05MmYzMDBjYTY3NzMiLCJhdXRoX3RpbWUiOjE3MDcyMzYxMDAsImlkcCI6ImxvY2FsIiwiRmVhdHVyZXMiOlsiYWRyZW1vdmUiLCJjb21iaW5hdGlvbnNjYW5zIiwidGVjaG5pY2FsY2hhcnQiLCJzY2FubGV2ZWwxIiwiYWR2YW5jZWRmaWx0ZXIiLCJjb21tdW5pdHkiLCJyZWFkeXdhdGNobGlzdHMiLCJyZWFkeWludmVzdG9yZ3JvdXBzIiwicmVhZHljb21iaW5hdGlvbnNjYW5zIiwid2ViaW5hcjEiLCJub3RlcyIsIm1mcmVhZHl3YXRjaGxpc3RzIiwicmVhZHlidXNpbmVzc2dyb3VwcyIsImVkZ2VyZXBvcnQiLCJjb3Jwb3JhdGVhbm5vdW5jZW1lbnQiLCJkb3dubG9hZCIsInJlYWR5aW52ZXN0bWVudHN0b2NrcyIsImRlcml2YXRpdmVhbmFseXRpY3MiLCJtYXJrZXRicmVhZHRoIiwiY2hhcnRwYXR0ZXJuIiwic2VjdG9ycm90YXRpb24iLCJ0YWJjdXN0b21pemF0aW9uIiwic29jaWFsLnF1ZXJ5Y2x1YnMiLCJzb2NpYWwucmVjb2NsdWJzIiwic29jaWFsLmJyb2tlcmNsdWJzIiwic29jaWFsLmxlYXJuaW5nY2x1YnMiLCJ0ZWNobmljYWxwZWVyIiwic29jaWFsLmV4cGVyaWVuY2UiLCJpbmR1c3RyeXJvdGF0aW9uIiwiaW5zaWdodGxldmVsMSIsImluc2lnaHRsZXZlbDIiLCJzZWN0b3JhbmFseXRpY3MiXSwianRpIjoiNTM4MEY4MzE1QjlDNENFMzczMENCMTIzQ0EzQjEzNzgiLCJpYXQiOjE3MDcyNzg4NDQsInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJlbWFpbCIsInNvY2lhbC5hcHAiLCJvZmZsaW5lX2FjY2VzcyJdLCJhbXIiOlsicHdkIl19.DYyPZUXs2ZOp1SycRQSLHjt-Qn-whYmFfaVK3bxA59eRiJX-ZGe4_iczZwQma2fZNFMSAq706HJXXH0TsszlYxH3_rRuKsyBAEFgHzhJQDcSQU1jui29YcukQQV950Sso2i8YqcN2NIatIt6Sy3fudc3sK_jOtGcnE50KOntu3jsz6coils9vMz0RB1xlazkrMrX01K6HRGm9DGN5eCRkem5a7HuJNt-8oJnqtCdogjPPERGPq0ifGWPNYllynLT3zWFjuWejGHBiUS-tDGUTZn1dsCxmoKz90iT66R2PAtpNDK3jP5o2IoisRbpnZt9T0a3ssmEuINusSIsKotzWw`

const Provider: FC = ({ children }) => {
  const { user, signinSilent } = useAuth();

  const requestLink = new ApolloLink(
    (operation, forward) =>
      new Observable((observer) => {
        let handle: any;
        Promise.resolve(operation)
          .then((operation) => {
            const accessToken = user?.access_token;
            if (accessToken) {
              operation.setContext({
                headers: {
                  authorization: `Bearer ${accessToken}`,
                },
              });
            }
          })
          .then(() => {
            handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            });
          })
          .catch(observer.error.bind(observer));

        return () => {
          if (handle) handle.unsubscribe();
        };
      })
  );

  const httpLink = new HttpLink({
    uri: GRAPHQL_API_URL,
    // credentials: 'include',
  });

  const wsLink = new WebSocketLink({
    uri: GRAPHQL_SUBSCRIPTION_URL,
    options: {
      reconnect: true,
      connectionParams: () => {
        const accessToken = user?.access_token;
        if (accessToken) {
          return {
            Authorization: `Bearer ${accessToken}`,
          };
        } else {
          return {};
        }
      },
    },
  });

  // const retryLink = new RetryLink({
  //   delay: {
  //     initial: 100,
  //     max: 5000,
  //   },
  //   attempts: {
  //     max: 3,
  //     retryIf: async (error) => {
  //       console.dir(error)
  //       if (error?.statusCode === 401) {
  //         console.log("Silent Signin")
  //         await signinSilent();
  //       }
  //       return true;
  //     },
  //   },
  // });

  // const retryLink = new RetryLink({
  //   delay: {
  //     initial: 300,
  //     max: Infinity,
  //     jitter: true
  //   },
  //   attempts: {
  //     max: 2,
  //     retryIf: async (error, operation) => {
  //       console.log({ error, operation })
  //       if (error?.statusCode === 401) {
  //         const user = await signinSilent();
  //         console.log("Retry Link", user);
  //         const accessToken = user?.access_token;
  //         // operation.setContext({
  //         //   headers: {
  //         //     authorization: `Bearer ${accessToken}`,
  //         //   }
  //         // })
  //         console.log(operation.operationName)
  //         return false;
  //         // signinSilent().then(user => {
  //         //   console.log("Retry Link", user);
  //         //   const accessToken = user?.access_token;
  //         //   operation.setContext({
  //         //     headers: {
  //         //       authorization: `Bearer ${accessToken}`,
  //         //     }
  //         //   })
  //         // }).catch(e => console.log("Retry Error", e));

  //       }
  //       return false;
  //     }
  //   }
  // });

  const link = ApolloLink.from([requestLink, httpLink]);
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    link
  );

  const client = new ApolloClient({
    link: splitLink,
    cache,
    connectToDevTools: true,
    queryDeduplication: true,
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default Provider;

// Methods for Inmemory Updation
export const updateCacheOnFollowHashTag = (
  cache: ApolloCache<any>,
  hashtag: Maybe<Hashtag> | undefined
) => {
  if (hashtag) {
    cache.modify({
      fields: {
        getHashtagFollowings(existingHashtags, { storeFieldName }) {
          const newHashTagRef = cache.writeFragment({
            data: Object.assign({}, hashtag, {
              isfollow: 1,
              issubscribed: 0,
              followers: hashtag?.followers ?? 0 + 1,
            }),
            fragment: HashTagFieldsFragmentDoc,
          });
          return [newHashTagRef, ...existingHashtags];
        },
      },
    });
    cache.updateFragment(
      {
        id: cache.identify(hashtag),
        fragment: UpdateHashtagFragmentDoc,
      },
      (d) => ({
        ...d,
        isfollow: 1,
        issubscribed: 0,
        followers: d.followers + 1,
      })
    );
  }
};

export const updateCacheOnUnFollowHashTag = (
  cache: ApolloCache<any>,
  hashtag: Maybe<Hashtag> | undefined
) => {
  if (hashtag) {
    cache.modify({
      fields: {
        getHashtagFollowings: (existingHashtags, { readField }) => {
          return existingHashtags.filter(
            (hashTagRef: any) =>
              hashtag.hashtagName !== readField("hashtagName", hashTagRef)
          );
        },
      },
    });
    cache.updateFragment(
      {
        id: cache.identify(hashtag),
        fragment: UpdateHashtagFragmentDoc,
      },
      (d) => ({
        ...d,
        isfollow: 0,
        issubscribed: 0,
        followers: d.followers - 1,
      })
    );
  }
};

export const updateCacheOnSubscribeHashTag = (
  cache: ApolloCache<any>,
  hashtag: Maybe<Hashtag> | undefined
) => {
  if (hashtag) {
    cache.updateFragment(
      {
        id: cache.identify(hashtag),
        fragment: UpdateHashtagFragmentDoc,
      },
      (d) => ({
        ...d,
        issubscribed: 1,
      })
    );
  }
};

export const updateCacheOnUnsubscribeHashTag = (
  cache: ApolloCache<any>,
  hashtag: Maybe<Hashtag> | undefined
) => {
  if (hashtag) {
    cache.updateFragment(
      {
        id: cache.identify(hashtag),
        fragment: UpdateHashtagFragmentDoc,
      },
      (d) => ({
        ...d,
        issubscribed: 0,
      })
    );
  }
};

export const updateCacheOnFollowDollarTag = (
  cache: ApolloCache<any>,
  dollar: Maybe<DollarTag> | undefined,
  data: DollarFollowMutation | null | undefined
) => {
  if (dollar) {
    cache.modify({
      fields: {
        getWatchlistV2: (existingTodos, { storeFieldName }) => {
          const newTodoRef = cache.writeFragment({
            data: Object.assign({}, dollar, data?.dollarFollow),
            fragment: DollarTagFieldsFragmentDoc,
          });
          if (
            dollar.dollarTagType === DollarTagEnum.Stock &&
            storeFieldName === 'getWatchlistV2:{"type":"Stock"}'
          ) {
            return [newTodoRef, ...existingTodos];
          }
          if (
            [DollarTagEnum.Sector, DollarTagEnum.Industry].includes(
              dollar.dollarTagType
            ) &&
            storeFieldName === 'getWatchlistV2:{"type":"Sector"}'
          ) {
            return [newTodoRef, ...existingTodos];
          }
          return existingTodos;
        },
      },
    });
  }
};

export const updateCacheOnUnFollowDollarTag = (
  cache: ApolloCache<any>,
  dollar: Maybe<DollarTag> | undefined,
  data: DollarFollowMutation | null | undefined
) => {
  if (dollar) {
    cache.modify({
      fields: {
        getWatchlistV2: (existingTodos, { storeFieldName, readField }) => {
          if (storeFieldName === 'getWatchlistV2:{"type":"Stock"}') {
            return existingTodos.filter(
              (dollarTagRef: any) =>
                dollar?.dollarTagId !== readField("dollarTagId", dollarTagRef)
            );
          }
          if (storeFieldName === 'getWatchlistV2:{"type":"Sector"}') {
            return existingTodos.filter(
              (dollarTagRef: any) =>
                dollar?.dollarTagId !== readField("dollarTagId", dollarTagRef)
            );
          }
          return existingTodos;
        },
      },
    });
  }
};

export const updateCacheOnFollowUser = (
  cache: ApolloCache<any>,
  user: Maybe<User> | undefined,
  data: FollowMutation | null | undefined
) => {
  if (user) {
    cache.modify({
      fields: {
        getSuggestedPeople(existingUsers, { readField }) {
          return existingUsers.filter(
            (userRef: any) => user.id !== readField("id", userRef)
          );
        },
        getFollowersCount(existing, { storeFieldName }) {
          if (
            storeFieldName ===
              `getFollowersCount({"data":{"entity":"User","id":"${user.id}"}})` &&
            data?.follow?.followStatus === "Resolved"
          ) {
            return existing + 1;
          }
          return existing;
        },
      },
    });
    cache.updateFragment(
      {
        id: cache.identify(user),
        fragment: UpdateUserFragmentDoc,
      },
      (d) => ({
        ...d,
        isfollow: data?.follow?.followStatus,
      })
    );
  }
};

export const updateCacheOnUnfollowUser = (
  cache: ApolloCache<any>,
  user: Maybe<User> | undefined,
  data: UnfollowMutation | null | undefined
) => {
  if (user) {
    cache.modify({
      fields: {
        getFollowersCount(existing, { storeFieldName }) {
          if (
            storeFieldName ===
            `getFollowersCount({"data":{"entity":"User","id":"${user.id}"}})`
          ) {
            return existing - 1;
          }
          return existing;
        },
      },
    });
    cache.updateFragment(
      {
        id: cache.identify(user),
        fragment: UpdateUserFragmentDoc,
      },
      (d) => ({
        ...d,
        isfollow: "False",
        issubscribed: 0,
      })
    );
  }
};

export const updateCacheOnCancelFollowUser = (
  cache: ApolloCache<any>,
  user: Maybe<User> | undefined,
  data: CancelFollowMutation | null | undefined
) => {
  if (user) {
    cache.updateFragment(
      {
        id: cache.identify(user),
        fragment: UpdateUserFragmentDoc,
      },
      (d) => ({
        ...d,
        isfollow: "False",
        issubscribed: 0,
      })
    );
  }
};

export const updateCacheOnSubscribeUser = (
  cache: ApolloCache<any>,
  user: Maybe<User> | undefined,
  data: SubscribeMutation | null | undefined
) => {
  if (user) {
    console.log("updateCacheOnSubscribeUser");
    cache.updateFragment(
      {
        id: cache.identify(user),
        fragment: UpdateUserFragmentDoc,
      },
      (d) => ({
        ...d,
        issubscribed: 1,
      })
    );
  }
};

export const updateCacheOnUnsubscripeUser = (
  cache: ApolloCache<any>,
  user: Maybe<User> | undefined,
  data: UnsubscribeMutation | null | undefined
) => {
  if (user) {
    console.log("updateCacheOnUnsubscripeUser");
    cache.updateFragment(
      {
        id: cache.identify(user),
        fragment: UpdateUserFragmentDoc,
      },
      (d) => ({
        ...d,
        issubscribed: 0,
      })
    );
  }
};

export const updateCacheOnJoinClub = (
  cache: ApolloCache<any>,
  user: Maybe<User> | undefined,
  club: Maybe<Club> | undefined,
  data: JoinClubMutation | null | undefined
) => {
  if (club) {
    // Add user to club member
    cache.modify({
      fields: {
        getMembers(existingMemberRefs, { storeFieldName }) {
          console.log({ storeFieldName });
          if (storeFieldName === `getMembers:{"clubId":"${club?.clubId}"}`) {
            const newMemberRef = cache.writeFragment({
              data: Object.assign({}, user, {
                __typename: "User",
              }),
              fragment: UserFieldsFragmentDoc,
            });
            return [newMemberRef, ...existingMemberRefs];
          }
          return existingMemberRefs;
        },
      },
    });
    cache.updateFragment(
      {
        id: cache.identify(club),
        fragment: UpdateClubFragmentDoc,
      },
      (d) => ({
        ...d,
        ismember: "Resolved",
        issubscribed: 0,
        totalMemberCount: d.totalMemberCount + 1,
      })
    );
  }
};

export const updateCacheOnLeaveClub = (
  cache: ApolloCache<any>,
  user: Maybe<User> | undefined,
  club: Maybe<Club> | undefined,
  data: LeaveClubMutation | null | undefined
) => {
  if (club) {
    // Add user to club member
    cache.modify({
      fields: {
        getMembers: (existingMemberRefs, { storeFieldName, readField }) => {
          console.log({ storeFieldName });
          if (storeFieldName === `getMembers:{"clubId":"${club?.clubId}"}`) {
            return existingMemberRefs.map(
              (memberRef: any) => user?.id !== readField("id", memberRef)
            );
          }
          return existingMemberRefs;
        },
      },
    });
    cache.updateFragment(
      {
        id: cache.identify(club),
        fragment: UpdateClubFragmentDoc,
      },
      (d) => ({
        ...d,
        ismember: "False",
        issubscribed: 0,
        totalMemberCount: d.totalMemberCount - 1,
      })
    );
  }
};

export const updateCacheOnSubscribeClub = (
  cache: ApolloCache<any>,
  club: Maybe<Club> | undefined,
  data: SubscribeClubMutation | null | undefined
) => {
  if (club) {
    cache.updateFragment(
      {
        id: cache.identify(club),
        fragment: UpdateClubFragmentDoc,
      },
      (d) => ({
        ...d,
        issubscribed: 1,
      })
    );
  }
};

export const updateCacheOnUnsubscribeClub = (
  cache: ApolloCache<any>,
  club: Maybe<Club> | undefined,
  data: UnsubscribeClubMutation | null | undefined
) => {
  if (club) {
    cache.updateFragment(
      {
        id: cache.identify(club),
        fragment: UpdateClubFragmentDoc,
      },
      (d) => ({
        ...d,
        issubscribed: 0,
      })
    );
  }
};

export const updateCacheOnUpvoteReply = (
  cache: ApolloCache<any>,
  reply: Maybe<Reply> | undefined,
  data: UpvoteMutation | null | undefined
) => {
  if (reply) {
    cache.updateFragment(
      {
        id: cache.identify({
          replyId: reply.replyId,
          __typename: reply.__typename,
        }),
        fragment: UpdateReplyFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 1,
        isDownvoted: 0,
        upvotecount: data?.upvote?.upvotes,
        downvotecount: data?.upvote?.downvotes,
      })
    );
  }
};

export const updateCacheOnRemoveUpvoteReply = (
  cache: ApolloCache<any>,
  reply: Maybe<Reply> | undefined,
  data: RemoveUpvoteMutation | null | undefined
) => {
  if (reply) {
    cache.updateFragment(
      {
        id: cache.identify(reply),
        fragment: UpdateReplyFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 0,
        isDownvoted: 0,
        upvotecount: data?.removeUpvote?.upvotes,
        downvotecount: data?.removeUpvote?.downvotes,
      })
    );
  }
};

export const updateCacheOnDownvoteReply = (
  cache: ApolloCache<any>,
  reply: Maybe<Reply> | undefined,
  data: DownvoteMutation | null | undefined
) => {
  if (reply) {
    cache.updateFragment(
      {
        id: cache.identify(reply),
        fragment: UpdateReplyFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 0,
        isDownvoted: 1,
        upvotecount: data?.downvote?.upvotes,
        downvotecount: data?.downvote?.downvotes,
      })
    );
  }
};

export const updateCacheOnRemoveDownvoteReply = (
  cache: ApolloCache<any>,
  reply: Maybe<Reply> | undefined,
  data: RemoveDownvoteMutation | null | undefined
) => {
  if (reply) {
    cache.updateFragment(
      {
        id: cache.identify(reply),
        fragment: UpdateReplyFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 0,
        isDownvoted: 0,
        upvotecount: data?.removeDownvote?.upvotes,
        downvotecount: data?.removeDownvote?.downvotes,
      })
    );
  }
};

export const updateCacheOnUpvoteComment = (
  cache: ApolloCache<any>,
  comment: Maybe<Comment> | undefined,
  data: UpvoteMutation | null | undefined
) => {
  if (comment) {
    cache.updateFragment(
      {
        id: cache.identify(comment),
        fragment: UpdateCommentFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 1,
        isDownvoted: 0,
        upvotecount: data?.upvote?.upvotes,
        downvotecount: data?.upvote?.downvotes,
      })
    );
  }
};

export const updateCacheOnRemoveUpvoteComment = (
  cache: ApolloCache<any>,
  comment: Maybe<Comment> | undefined,
  data: RemoveUpvoteMutation | null | undefined
) => {
  if (comment) {
    cache.updateFragment(
      {
        id: cache.identify(comment),
        fragment: UpdateCommentFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 0,
        isDownvoted: 0,
        upvotecount: data?.removeUpvote?.upvotes,
        downvotecount: data?.removeUpvote?.downvotes,
      })
    );
  }
};

export const updateCacheOnDownvoteComment = (
  cache: ApolloCache<any>,
  comment: Maybe<Comment> | undefined,
  data: DownvoteMutation | null | undefined
) => {
  if (comment) {
    cache.updateFragment(
      {
        id: cache.identify(comment),
        fragment: UpdateCommentFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 0,
        isDownvoted: 1,
        upvotecount: data?.downvote?.upvotes,
        downvotecount: data?.downvote?.downvotes,
      })
    );
  }
};

export const updateCacheOnRemoveDownvoteComment = (
  cache: ApolloCache<any>,
  comment: Maybe<Comment> | undefined,
  data: RemoveDownvoteMutation | null | undefined
) => {
  if (comment) {
    cache.updateFragment(
      {
        id: cache.identify(comment),
        fragment: UpdateCommentFragmentDoc,
      },
      (d) => ({
        ...d,
        isUpvoted: 0,
        isDownvoted: 0,
        upvotecount: data?.removeDownvote?.upvotes,
        downvotecount: data?.removeDownvote?.downvotes,
      })
    );
  }
};
